import { render } from "./discoveryBannerDialog.vue?vue&type=template&id=60a44cd0&scoped=true"
import script from "./discoveryBannerDialog.vue?vue&type=script&lang=js"
export * from "./discoveryBannerDialog.vue?vue&type=script&lang=js"

import "./discoveryBannerDialog.vue?vue&type=style&index=0&id=60a44cd0&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60a44cd0"]])

export default __exports__